import * as Sentry from '@sentry/react';

import { getCurrentPath } from '../../selectors/router';
import { getCustomerId } from '../../selectors/customer';
import { isSentryEnabled } from '../logging';
import store from '../../store';

const logException = (exception, context) => {
  const additionalData = {
    ...context,
  };

  const state = store.getState();
  const pathname = getCurrentPath(state);

  Sentry.setTag('customer.id', getCustomerId(state));

  if (pathname.includes('/booking/')) {
    const [, , bookingReference] = pathname.split('/');
    if (bookingReference) {
      Sentry.setTag('booking.reference', bookingReference);
    }
  }

  Sentry.captureException(exception, additionalData);
};

const captureException = (exception, context) => {
  if (isSentryEnabled()) {
    logException(exception, context);
  }

  // eslint-disable-next-line no-console
  console.error('captureException:', exception, context);
  return Promise.reject(exception);
};

export const axiosInterceptors = error => {
  const errorMessage = error?.message ?? '';
  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    return captureException(errorMessage, error?.response?.data);
  } else if (error.request) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    return captureException(errorMessage, error?.request);
  }

  return captureException(errorMessage);
};

export default captureException;
